import { Channel } from '@smatchy/chat-client';

export class GetChatsAction {
  static readonly type = '[Messaging] GetChatsAction';

  constructor(public readonly archived = false) {}
}

export class SetLoadingChatAction {
  static readonly type = '[Messaging] SetLoadingChatAction';
}

export class GetChatAction {
  static readonly type = '[Messaging] GetChatAction';

  constructor(public readonly chatId: string) {}
}

export class GetChatLoadedAction {
  static readonly type = '[Messaging] GetChatLoadedAction';
}

export class LoadMoreMessagesAction {
  static readonly type = '[Messaging] LoadMoreMessagesAction';

  constructor(public readonly count = 50, public readonly chatId?: string) {}
}

export class JoinChatChannelAction {
  static readonly type = '[Messaging] JoinChatChannelAction';

  constructor(public readonly channel: Channel) {}
}

export class LeaveChatChannelAction {
  static readonly type = '[Messaging] LeaveChatChannelAction';
}

export class SendMessageTextAction {
  static readonly type = '[Messaging] SendMessageTextAction';

  constructor(public readonly text: string) {}
}

export class HandleNotReadMessagesAction {
  static readonly type = '[Messaging] HandleNotReadMessagesAction';

  constructor(public readonly messageIds: string[]) {}
}

export class NewMessageReceivedAction {
  static readonly type = '[Messaging] NewMessageReceivedAction';
}

export class SyncArchivedChatViewAction {
  static readonly type = '[Messaging] SyncArchivedChatViewAction';

  constructor(public readonly chatId: string) {}
}

/** SMA-22: one reaction per person, see applyMessageReaction. */
export class ReactToMessageAction {
  static readonly type = '[Messaging] ReactToMessageAction';

  constructor(public readonly messageId: string, public readonly emoji: string) {}
}
